import { Avatar, Badge, VStack } from '@genial/components';
import { ColorTypes } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Tooltip } from 'native-base';
import React from 'react';

interface SuitabilityProfileProps {
  value: string;
  forceBadge?: boolean;
}

export const SuitabilityProfile: React.FC<SuitabilityProfileProps> = ({
  value,
  forceBadge = false,
}) => {
  const testID = 'resume-suitability-profile';
  const colorLowerCase = value?.toLowerCase() || 'conservador';
  const color = `risk.${colorLowerCase}` as ColorTypes.Option;
  const isTablet = useBreakpointValue({ base: false, sm: true, lg: false });

  if (isTablet && !forceBadge) {
    return (
      <Tooltip testID={`${testID}-tooltip`} label={value || ''}>
        <VStack>
          <Avatar
            bgColor={color}
            initials={value}
            testId={`${testID}-avatar`}
            textColor="neutral.white"
          />
        </VStack>
      </Tooltip>
    );
  }
  return (
    <Badge testId={`${testID}-badge`} backgroundColor={color} textColor="neutral.white">
      {value}
    </Badge>
  );
};
